import React from "react";
import {
  Container,
  Title,
  ImageContainer,
  InnerContainer,
  TextContainer,
} from "./Sponsor.styled";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";
import { getStaticImg } from "../../../utils/function";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const Sponsor = ({ title, contents, titleClassName = "" }) => {
  const { size } = useWindowSize();

  const handleClick = (val) => {
    if (val?.content_url) {
      return window.open(val.content_url, "_blank");
    } else return false;
  };
  const isMobileView = (size?.width || 0) <= 768;
  return (
    <>
      <Container>
        <img
          id="title-img"
          className="mx-auto z-20 lg:max-w-[428px] lg:h-auto h-[36px]"
          style={{
            // maxWidth: "428px",

            objectFit: "contain",
            objectPosition: "center",
          }}
          src={getStaticImg("illustration/sponsored-by.png")}
          alt={title || "Sponsored By"}
        />
        {/* {<Title className={titleClassName}>{title}</Title>} */}
        <InnerContainer>
          {contents?.map((value, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                flexDirection: "column",
                //  backgroundColor: "#EAEBF1",
                height: isMobileView ? "64px" : "auto",
                borderRadius: 24,
                marginBottom: idx === contents?.length - 1 ? "24px" : "auto",
                cursor: value?.content_url?.length ? "pointer" : "default",
              }}
              onClick={() => handleClick(value)}
            >
              <ImageContainer
                key={idx}
                cursor={value?.content_url?.length ? "pointer" : "default"}
              >
                <img
                  src={imgPath + value?.key_visual}
                  className="lg:w-[357px] w-[200px] object-contain z-20"
                />
              </ImageContainer>
              {/* <TextContainer>
                <div
                  className="flex text-center items-center justify-center"
                  style={{
                    fontSize: 14,
                    lineHeight: "19px",
                    color: "#1F2D3D",
                    fontWeight: "bold",
                  }}
                >
                  Kunjungi Halaman Situs
                  <img
                    src={func.getStaticImg("/icon/right-arrow.svg")}
                    style={{
                      marginLeft: 8,
                      filter: "brightness(0) saturate(0) contrast(100%)",
                      height: 24,
                      width: 24,
                    }}
                  ></img>
                </div>
              </TextContainer> */}
            </div>
          ))}
        </InnerContainer>
      </Container>
    </>
  );
};

export default Sponsor;
